import styled from 'styled-components';

const ContentWrapper = styled.div`
  width: 85.76%;
  max-width: 1500px;
  margin: 0 auto 45px auto;
`;

export default ContentWrapper;
